import { CancelDayOff } from 'features/cancelDayOff';
import { useTitle } from '../helpers';

/**
 * @page CancelDayOffPage page
 */
const CancelDayOffPage = () => {
  useTitle('Отмена отгулов');

  return (
    <div>
      <CancelDayOff />
    </div>
  );
};

export default CancelDayOffPage;
